<template>
  <div class="upper_left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      background-color="#072A59"
      text-color="#888888"
      active-text-color="#ffffff"
      class="el-menu-vertical-demo" >
      <el-menu-item index="1" @click="toNewRouter('upper-information-group-profile-info')" >
        <i class="el-icon-damai-yuanqu1"></i>
        <span slot="title">集团概况</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('upper-information-honor-qualification-manage')" >
        <i class="el-icon-damai-rongyu"></i>
        <span slot="title">荣誉资质</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('upper-information-yq-notice-manage', {type: '1'})" >
        <i class="el-icon-damai-gonggao"></i>
        <span slot="title">通知公告</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('upper-information-yq-notice-manage', {type: '3'})" >
        <i class="el-icon-damai-wj-dwj"></i>
        <span slot="title">智慧党建</span>
      </el-menu-item>
      <el-menu-item index="5" @click="toNewRouter('upper-information-yq-notice-manage', {type: '2'})" >
        <i class="el-icon-damai-zhengce"></i>
        <span slot="title">最新政策</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('upper-information-yq-notice-manage', {type: '0'})" >
        <i class="el-icon-damai-zixun"></i>
        <span slot="title">要文快讯</span>
      </el-menu-item>
      <el-menu-item index="7" @click="toNewRouter('upper-information-yq-notice-manage', {type: '4'})" >
        <i class="el-icon-damai-article"></i>
        <span slot="title">其他资讯</span>
      </el-menu-item>
      <!--<el-menu-item index="8" @click="toNewRouter('')" >-->
        <!--<i class="el-icon-damai-huodong1"></i>-->
        <!--<span slot="title">热门活动</span>-->
      <!--</el-menu-item>-->
      <!--<el-menu-item index="10" @click="toNewRouter('')" >-->
        <!--<i class="el-icon-damai-ic_caozuorizhi"></i>-->
        <!--<span slot="title">操作日志</span>-->
      <!--</el-menu-item>-->

      <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 20px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div>
    </el-menu>
  </div>
</template>

<script>
import navMixin from '../../../../utils/nav'
import {bus} from '../../../../utils/bus'

const indexOfRouterNameEntities = Object.entries({
  '1': ['upper-information-group-profile-info', 'upper-information-group-profile-info-modify'],
  '2': ['upper-information-honor-qualification-manage', 'upper-information-add-honor-qualification', 'upper-information-modify-honor-qualification'],
})
export default {
  name: 'resource-nav',
  mixins: [navMixin],
  data () {
    return {
      isCollapse: false,
      indexOfRouterNameEntities,
      permissionCodes: ''
    }
  },
  created () {
    this.permissionCodes = bus.global.permissionCodes
  },
  computed:{
    defaultActiveMenuIndex () {
      const {name: routeName} = this.$route
      console.log(this.$route)
      const entity = indexOfRouterNameEntities
        .find(([, routeNames]) => {
          if (routeNames instanceof Array) {
            return routeNames.indexOf(routeName) >= 0
          } else {
            return routeNames === routeName
          }
        })
      if (routeName === 'upper-information-add-yq-notice' || routeName === 'upper-information-modify-yq-notice' || routeName === 'upper-information-yq-notice-manage') {
        if (this.$route.params.type === '1') {
          return '3'
        } else if (this.$route.params.type === '2') {
          return '5'
        } else if (this.$route.params.type === '3') {
          return '4'
        } else if (this.$route.params.type === '0') {
          return '6'
        } else if (this.$route.params.type === '4') {
          return '7'
        }
      } else {
        return entity && entity[0]
      }
    }
  },
  methods: {
    toNewRouter (name, params) {
      this.$router.push({
        name: name,
        params: params
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .upper_left_nav {
    height: 100%;
    background-color: #072A59;
    .el-menu-vertical-demo:not(.el-menu--collapse) {
      width: 220px;
    }
    .el-submenu__title {
      /*border-left: 5px solid #FFFFFF;*/
      text-align: left;
    }
    .el-menu-item {
      /*border-left: 5px solid #FFFFFF;*/
      text-align: left;
    }
    .el-submenu .el-menu-item {
      text-align: left;
      padding-left: 80px!important;
    }
    .el-menu-item .is-active {
      background-color: #ecf5ff;
    }
    .is-active, .el-menu-item:hover {
      /*border-left: 5px solid #00A0E6 !important;*/
      color: #ffffff;
      /*.el-submenu__title {*/
      /*border-left: 0 !important;*/
      /*}*/
    }
    .el-menu {
      border-right: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/UpperStrata/Summary/InformationDelivery/InformationDeliveryNav.vue